import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import storage from "redux-persist/lib/storage"; // Lưu
//  trữ trong localStorage
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import authModalSlice from "./features/authModalSlice";
import cartReducer from "./features/cartState";
import orderReducer from "./features/orderSlide";
import userSlice from "./features/userSlice";
import expiredModalSlice from "./features/expiredModalSlice";
import cartBookingReducer from "./features/cartStateBooking";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  expiredModal: expiredModalSlice,

  auth: authReducer,
  authModal: authModalSlice,
  cart: cartReducer,
  cartBooking: cartBookingReducer,
  order: orderReducer,
  // user: userSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
